import { useEffect } from 'react';

/**
 * Meta Pixel base code — Wrestling Practice Ready.
 * Single source of truth: the only pixel on the page and the only place it is
 * initialised. Fires exactly ONE PageView per page load.
 *
 * Note: no <noscript> image fallback is injected. When built from JavaScript,
 * setting an <img> src makes the browser request it immediately, which sent a
 * second PageView. The fallback only matters with JS disabled, where this
 * React app would not run anyway.
 */
const PIXEL_ID = '2293153411434610';
type PixelWindow = Window & {
  fbq?: unknown;
  __metaPixelInjected?: boolean;
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as PixelWindow;
    if (w.__metaPixelInjected || w.fbq) return;
    w.__metaPixelInjected = true;
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
  }, []);
  return null;
}